<template>
  <div class="container mx-auto px-4 py-8">
    <div class="flex justify-between items-center mb-6">
      <h1 class="text-3xl font-bold">Lịch sử nghe truyện</h1>
      <router-link to="/" class="text-sm text-gray-400 hover:text-white transition-colors">
        <i class="fa-solid fa-chevron-left mr-2"></i>
        Trở về trang chủ
      </router-link>
    </div>

    <div v-if="sortedHistory.length > 0" class="space-y-4">
      <div v-for="item in sortedHistory" :key="item.slug" class="p-4 rounded-lg bg-[var(--card-bg-color)] border border-[var(--border-color)] flex flex-col sm:flex-row justify-between sm:items-center gap-4">
        <div>
          <h2 class="text-xl font-bold">{{ item.storyName }}</h2>
          <p class="text-sm text-gray-400 mb-2">Tác giả: {{ item.author }}</p>
          <p class="text-sm">
            <i class="fa-solid fa-headphones-simple mr-2 text-gray-400"></i>
            Đã nghe đến: <strong>{{ item.chapterName }}</strong>
          </p>
          <p class="text-xs text-gray-500 mt-2">
             <i class="fa-solid fa-clock mr-2"></i>
            {{ new Date(item.timestamp).toLocaleString() }}
          </p>
        </div>
        <button @click="continueListening(item)" class="flex-shrink-0 flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg text-white font-bold transition-transform transform hover:scale-105 text-sm">
            <i class="fa-solid fa-play"></i>
            <span>Nghe tiếp</span>
        </button>
      </div>
    </div>
    <div v-else class="text-center py-16 bg-[var(--card-bg-color)] rounded-lg">
      <p class="text-xl font-semibold">Chưa có lịch sử nghe truyện</p>
      <p class="text-gray-400 mt-2">Lịch sử sẽ được lưu lại khi bạn bắt đầu nghe một chương truyện.</p>
      <router-link to="/" class="mt-6 inline-block px-5 py-2.5 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors">
        Khám phá truyện
      </router-link>
    </div>
  </div>
</template>

<script>
import { inject } from 'vue';

export default {
  name: 'HistoryView',
  setup() {
    const audioState = inject('audioState');
    return { audioState };
  },
  data() {
    return {
      history: []
    };
  },
  computed: {
    sortedHistory() {
      // Tạo một bản sao của mảng history trước khi sắp xếp để tránh side effect
      return [...this.history].sort((a, b) => b.timestamp - a.timestamp);
    }
  },
  created() {
    this.loadHistory();
    document.title = 'Lịch sử nghe truyện';
  },
  methods: {
    loadHistory() {
      const historyData = JSON.parse(localStorage.getItem('full-audio-history') || '{}');
      this.history = Object.values(historyData);
    },
    async continueListening(historyItem) {
        // Fetch story details to get the full chapter list and deployment_url
        const response = await fetch(`/data/${historyItem.slug}.json`);
        if (!response.ok) {
            console.error('Không thể tải chi tiết truyện');
            return;
        }
        const storyDetails = await response.json();
        storyDetails.slug = historyItem.slug;

        // Use the global audio state to start playing
        this.audioState.setTrack(storyDetails, historyItem.chapterIndex);
    }
  }
};
</script>
